import { createReducer } from '@reduxjs/toolkit';
import { UPDATE_THD_STORE_INFO } from '../actions';

const thdStoreInfo = createReducer({},
  (builder) => {
    builder
      .addCase(UPDATE_THD_STORE_INFO, (state, action) => {
        return action.thdStoreInfo ? ({ ...state, ...action.thdStoreInfo }) : state;
      });
  }
);
export default thdStoreInfo;
